<div class="auth-card">
  <div class="dx-card content">
    <div class="header">
      <div class="title">{{ title }}</div>
      <div class="description">{{ description }}</div>
    </div>
    <ng-content></ng-content>
  </div>
</div>
